"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapperBuilder_1 = require("./MapperBuilder");
class Mail extends MapperBuilder_1.default {
    constructor() {
        super();
        this.setStatus({
            SEND: 'send',
            REJECT: 'reject',
            BOUNCE: 'bounce',
            COMPLAINT: 'complaint',
            DELIVERY: 'delivery',
            OPEN: 'open',
            CLICK: 'click',
            //takeblip whatsapp
            ACCEPTED: 'accepted',
            DISPATCHED: 'dispatched',
            RECEIVED: 'received',
            CONSUMED: 'consumed',
            FAILED: 'failed',
        });
        this.setTranslations({
            [this.statusList.SEND]: 'Enviado',
            [this.statusList.REJECT]: 'Falha no envio',
            [this.statusList.BOUNCE]: 'Recusado',
            [this.statusList.COMPLAINT]: 'Spam',
            [this.statusList.DELIVERY]: 'Entregue',
            [this.statusList.OPEN]: 'Aberto',
            [this.statusList.CLICK]: 'Clicado',
            //takeblip whatsapp
            [this.statusList.ACCEPTED]: 'Recebido pela TakeBlip',
            [this.statusList.DISPATCHED]: 'Enviado',
            [this.statusList.RECEIVED]: 'Recebido',
            [this.statusList.CONSUMED]: 'Lido',
            [this.statusList.FAILED]: 'Falha',
        });
        this.setAssertions({
            isSend: this.buildAssertFunc(this.statusList.SEND),
            isReject: this.buildAssertFunc(this.statusList.REJECT),
            isBounce: this.buildAssertFunc(this.statusList.BOUNCE),
            isComplaint: this.buildAssertFunc(this.statusList.COMPLAINT),
            isDelivery: this.buildAssertFunc(this.statusList.DELIVERY),
            isOpen: this.buildAssertFunc(this.statusList.OPEN),
            isClick: this.buildAssertFunc(this.statusList.CLICK),
            isAccepted: this.buildAssertFunc(this.statusList.ACCEPTED),
            isDispatched: this.buildAssertFunc(this.statusList.DISPATCHED),
            isRecived: this.buildAssertFunc(this.statusList.RECEIVED),
            isConsumed: this.buildAssertFunc(this.statusList.CONSUMED),
            isFailed: this.buildAssertFunc(this.statusList.FAILED),
        });
    }
}
exports.default = Mail;
//# sourceMappingURL=Mail.js.map